<template lang="pug">
  .hero-product.row
    .hero-image.xs-12.md-4
      ProductInfoImage(:imagery="product.imagery")
    .hero-info.xs-12.md-8
      .prod-title.xs-f-xsmall.lg-f-small.max-at-tweak.upper.color-slate {{ product.name }}
      .prod-desc.xs-f-large.lg-f-xlarge.max-at-tweak {{ product.short_description }}
      slot
  
</template>

<script>
  import ProductInfoImage from "../../Purchases/ProductInfoImage";
  export default {
    name: "HeroProduct",
    components: {ProductInfoImage},
    props: {
      product: {
        type: Object,
        required: true,
        default: {}
      }
    }
   }
</script>

<style scoped lang="stylus">
  .hero-image
    padding 1em 1em 1em 0

  .hero-info
    padding-top 1em

  @media mq-mobile
    .hero-image
      padding 1em 3.5em

    .hero-info
      text-align center

  @media mq-tablet
    .hero-image
      padding 1em 3.5em

    .hero-info
      padding-top 1em
      text-align center

</style>
